import { render, staticRenderFns } from "./LogisticList.vue?vue&type=template&id=6b867d79&"
import script from "./LogisticList.vue?vue&type=script&lang=js&"
export * from "./LogisticList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports